var e = {
	title: {
		guest: "Get started with Maat",
		host: "Set up your workspace"
	},
	progress: "{{done}} of {{total}} done",
	nextBadge: "Next",
	inReview: "In review",
	cta: "Continue",
	strip: {
		title: "Finish setting up",
		remaining_one: "{{count}} step left",
		remaining_other: "{{count}} steps left",
		expand: "Open your setup checklist"
	},
	hide: "Hide for now",
	reentry: {
		label: "Finish setting up",
		description: "Pick up your checklist where you left off"
	},
	completed: {
		title: "You're all set!",
		guest: "You've unlocked everything Maat has to offer. Happy travels!",
		host: "Your workspace is fully set up. Here's to your first hundred bookings!"
	},
	dismiss: "Dismiss",
	steps: {
		create_account: {
			title: "Create your account",
			description: "Done the moment you joined — welcome aboard!"
		},
		complete_profile: {
			title: "Complete your profile",
			description: "Add your name and a profile photo so hosts know who's booking.",
			cta: "Add your details"
		},
		verify_identity: {
			title: "Verify your identity",
			description: "Upload an ID and a selfie — it keeps stays safe for everyone.",
			cta: "Verify now"
		},
		save_first_favorite: {
			title: "Save your first favorite",
			description: "Tap the heart on any stay that catches your eye.",
			cta: "Browse stays"
		},
		first_booking: {
			title: "Book your first stay",
			description: "Find a place you love and make it yours.",
			cta: "Find a stay"
		},
		create_workspace: {
			title: "Create your workspace",
			description: "Done — your hosting home base is ready."
		},
		create_first_listing: {
			title: "List your first property",
			description: "Publish a property so guests can find and book it.",
			cta: "List a property"
		},
		verify_host: {
			title: "Verify your hosting account",
			description: "Verified hosts earn more trust — and more bookings.",
			cta: "Verify now"
		},
		invite_cohost: {
			title: "Invite a co-host",
			description: "Share the work — bring a teammate on board.",
			cta: "Invite a co-host"
		},
		create_booking_rule: {
			title: "Add a booking rule",
			description: "Automate who can book, and when.",
			cta: "Add a rule"
		},
		first_booking_received: {
			title: "Get your first booking",
			description: "It's coming — a complete, verified listing seals the deal.",
			cta: "View bookings"
		}
	}
};
//#endregion
export { e as default };
